<div class="form-decorator flex w-full justify-content-left align-items-center">
  <div class="title">Kod</div>
  {{ data.code }}
</div>
<div class="form-decorator flex w-full justify-content-left align-items-center">
  <div class="title">Kod QR</div>
              <qrcode
              class="label-qr"
              [qrdata]="buildSignUpUrl(data.code)"
              [width]="100"
              [errorCorrectionLevel]="'M'"
              [elementType]="'svg'"
              [margin]="0"
            ></qrcode>
</div>
<div class="form-decorator flex w-full justify-content-left align-items-center">
  <div class="title">Wykorzystany</div>
  <div class="">
    {{ data.isUsed ? "Tak" : "Nie" }}
    <span *ngIf="data.isUsed && data.usedDate"
      >({{ data.usedDate | date: "dd.MM.yyyy" }})</span
    >
  </div>
</div>
<div class="form-decorator flex w-full justify-content-left align-items-center">
  <div class="title">Nazwa użytkownika</div>
  {{ data.usedByEmail }}
</div>
